import theme from '@ifca-root/react-component/src/assets/theme'
import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import IconText from '@ifca-root/react-component/src/components/Typography/IconText'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
} from '@material-ui/core'
import { KeyboardArrowRight, MoreVert } from '@material-ui/icons'
import LeftIconCardExpansion from 'components/CardExpansion/LeftIconCardExpansion'
import { DeleteDialog } from 'components/Dialog/DeleteDialog'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { advancedFilterList } from 'components/Filter/AdvancedFilter'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  ApprovalStatus,
  useDeleteProformaInvoiceMutation,
} from 'generated/graphql'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import { formatDate, formatTime } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import React, { Fragment, useContext, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory, useParams } from 'react-router'
import SubmitterLog from 'assets/icons/GeneralLedger/submitter-log.svg'
import { ProformaInvoicesDetailContent } from '../ProformaInvoicesDetail/ProformaInvoicesDetailContent'

export const ProformaInvoicesEntryList = (props: any) => {
  const {
    filteredList,
    ScheduledBillingbyStatusLoading,
    listStatus,
    fetchMore,
    setOriginalListing,
    setErrMessage,
    setErrDialog,
    userList,
  } = props

  const getSearch = JSON.parse(localStorage.getItem('searchFilter'))
  let history = useHistory()
  const { CompanyID, ScheduledBillingSubmenu }: any = useParams()
  const companyStatus = localStorage?.getItem('companyStatus')

  /* -------------------------------------------- */
  /*                     STATE                    */
  /* -------------------------------------------- */
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const { setOpenSnackBar, setSnackBarMsg } = useContext(SnackBarContext) as any
  const [deleteAA, setDeleteAA] = useState(false)
  const [errorDia, setErrorDia] = useState<boolean>(false)
  const [errMsg, setErrMsg] = useState<string>('')

  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  /* -------------------------------------------- */
  /*                     QUERY                    */
  /* -------------------------------------------- */
  const [
    deleteProformaInvoice,
    { loading: deleteProformaInvoiceLoading },
  ] = useDeleteProformaInvoiceMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOriginalListing([])
      fetchMore({
        variables: {
          CompanyID,
          StatusArr: 'ACTIVE',
          take: 30,
          skip: 0,
          searchValue:
            getSearch?.name === '' || getSearch?.name === undefined
              ? undefined
              : getSearch?.name,
        },
      })
    },
  })

  /* -------------------------------------------- */
  /*                     VARIABLE                 */
  /* -------------------------------------------- */
  const { handlePermDisabled } = usePermissionChecker()

  const handleDelete = data => {
    deleteProformaInvoice({
      variables: { input: { ProformaRequisitionID: data } },
    })
    setDeleteAA(false)
  }

  return (
    <>
      {deleteProformaInvoiceLoading && <Loading />}
      {ScheduledBillingbyStatusLoading && <Loading />}
      <ContentWrapper advSearch float>
        <List className="core-list">
          {advancedFilterList(filteredList) === undefined ||
          advancedFilterList(filteredList)?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                fetchMore({
                  variables: {
                    CompanyID: CompanyID,
                    StatusArr: [listStatus],
                    take: 30,
                    skip: currentLength,
                    searchValue:
                      getSearch?.name === '' || getSearch?.name === undefined
                        ? undefined
                        : getSearch?.name,
                  },
                })
              }}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                ScheduledBillingbyStatusLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {advancedFilterList(filteredList)?.map((el, index) => {
                if (listStatus === 'ACTIVE' || listStatus === 'REJECTED') {
                  return (
                    <LeftIconCardExpansion
                      expanded={true}
                      summary={
                        <>
                          <ListItemText
                            primary={
                              <Grid
                                container
                                className="desc flex-space text-noflow"
                              >
                                <Grid
                                  spacing={1}
                                  container
                                  className="table-content"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    style={{
                                      paddingRight: isDesktop ? '60px' : '15vw',
                                    }}
                                  >
                                    <span className={`xsTitle flex-space`}>
                                      {el?.DebtorName}
                                    </span>
                                    <span
                                      className="desc"
                                      style={{ float: 'right' }}
                                    >
                                      {`${formatDate(el?.TransactionDate)}`}
                                    </span>
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                            secondary={
                              <Grid
                                container
                                className="desc flex-space text-noflow"
                              >
                                <Grid
                                  spacing={1}
                                  container
                                  className="table-content"
                                >
                                  <Grid
                                    item
                                    xs={12}
                                    style={{
                                      paddingRight: isDesktop ? '60px' : '15vw',
                                    }}
                                  >
                                    <span style={{ fontSize: '10px' }}>
                                      {el?.title}
                                    </span>
                                    <span style={{ float: 'right' }}>
                                      <IconText
                                        parentStyle={{
                                          justifyContent: 'center',
                                        }}
                                        font="xxTitle c-orange"
                                        children={amtStr(el?.DocAmt)}
                                      />
                                    </span>
                                  </Grid>
                                </Grid>

                                <Grid
                                  spacing={1}
                                  container
                                  className="table-content"
                                >
                                  <Grid item xs={12}>
                                    <div className="icon-text">
                                      <Tooltip
                                        disableFocusListener
                                        title={
                                          <Fragment>
                                            <Grid
                                              container
                                              wrap="nowrap"
                                              spacing={2}
                                            >
                                              <Grid item>
                                                <IconText
                                                  icon={
                                                    <img
                                                      src={SubmitterLog}
                                                      style={{
                                                        width: '12px',
                                                        marginRight: '3px',
                                                      }}
                                                    />
                                                  }
                                                  font="desc"
                                                />
                                              </Grid>
                                              <Grid item xs zeroMinWidth>
                                                <div
                                                  style={{ fontSize: '12px' }}
                                                >
                                                  {userList?.find(
                                                    x =>
                                                      x?.ID === el?.approvedBy
                                                  )?.name ??
                                                    userList?.find(
                                                      x =>
                                                        x?.ID === el?.createdBy
                                                    )?.name}
                                                </div>
                                                <div
                                                  style={{ fontSize: '10px' }}
                                                >
                                                  {formatDate(
                                                    el?.approvedTs ??
                                                      el?.createdTs
                                                  )}{' '}
                                                  &nbsp;
                                                  {formatTime(
                                                    el?.approvedTs ??
                                                      el?.createdTs
                                                  )}
                                                </div>
                                              </Grid>
                                            </Grid>
                                          </Fragment>
                                        }
                                        arrow
                                        enterTouchDelay={0}
                                      >
                                        <div>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          />
                                        </div>
                                      </Tooltip>
                                      {listStatus !== 'SUBMIT' ? (
                                        <>
                                          <span
                                            className="desc text-noflow"
                                            style={{ display: 'contents' }}
                                          >
                                            {el?.Description}
                                          </span>
                                        </>
                                      ) : null}
                                    </div>
                                  </Grid>
                                </Grid>
                              </Grid>
                            }
                          />
                          <ListItemSecondaryAction>
                            <IconButton
                              edge="end"
                              aria-label="delete"
                              aria-controls="menu-list"
                              aria-haspopup="true"
                              onClick={e => {
                                e?.preventDefault()
                                handleClick(
                                  e,
                                  el?.ScheduledBillingID,
                                  index,
                                  el
                                )
                              }}
                            >
                              <MoreVert />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </>
                      }
                    >
                      <CardContents style={{ boxShadow: 'none', padding: '0' }}>
                        <ProformaInvoicesDetailContent
                          listEl={el}
                          listStatus={listStatus}
                          userList={userList}
                          mode="detail"
                        />
                      </CardContents>
                    </LeftIconCardExpansion>
                  )
                }
                return (
                  <ListItem>
                    <ListItemText
                      primary={
                        <>
                          <span className={`xsTitle flex-space`}>
                            {el?.DebtorName}
                          </span>
                          <span
                            className="desc"
                            style={{ justifyContent: 'end' }}
                          >
                            {`${formatDate(el?.TransactionDate)}`}
                          </span>
                        </>
                      }
                      secondary={
                        <Grid container className="desc flex-space text-noflow">
                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={9}>
                              <span style={{ fontSize: '10px' }}>
                                {el?.title}
                              </span>
                            </Grid>
                            <Grid item xs={3}>
                              <IconText
                                parentStyle={{ justifyContent: 'end' }}
                                font="xxTitle c-orange"
                                children={amtStr(el?.DocAmt)}
                              />
                            </Grid>
                          </Grid>

                          <Grid spacing={1} container className="table-content">
                            <Grid item xs={12}>
                              <div className="icon-text">
                                <Tooltip
                                  disableFocusListener
                                  title={
                                    <Fragment>
                                      <Grid container wrap="nowrap" spacing={2}>
                                        <Grid item>
                                          <IconText
                                            icon={
                                              <img
                                                src={SubmitterLog}
                                                style={{
                                                  width: '12px',
                                                  marginRight: '3px',
                                                }}
                                              />
                                            }
                                            font="desc"
                                          />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                          <div style={{ fontSize: '12px' }}>
                                            {userList?.find(
                                              x => x?.ID === el?.approvedBy
                                            )?.name ??
                                              userList?.find(
                                                x => x?.ID === el?.createdBy
                                              )?.name}
                                          </div>
                                          <div style={{ fontSize: '10px' }}>
                                            {formatDate(
                                              el?.approvedTs ?? el?.createdTs
                                            )}{' '}
                                            &nbsp;
                                            {formatTime(
                                              el?.approvedTs ?? el?.createdTs
                                            )}
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Fragment>
                                  }
                                  arrow
                                  enterTouchDelay={0}
                                >
                                  <div>
                                    <IconText
                                      icon={
                                        <img
                                          src={SubmitterLog}
                                          style={{
                                            width: '12px',
                                            marginRight: '3px',
                                          }}
                                        />
                                      }
                                      font="desc"
                                    />
                                  </div>
                                </Tooltip>
                                {listStatus !== 'SUBMIT' ? (
                                  <>
                                    <span
                                      className="desc text-noflow"
                                      style={{ display: 'contents' }}
                                    >
                                      {el?.Description}
                                    </span>
                                  </>
                                ) : null}
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      }
                    />
                    <ListItemSecondaryAction>
                      {listStatus === 'ACTIVE' || listStatus === 'REJECTED' ? (
                        <>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            aria-controls="menu-list"
                            aria-haspopup="true"
                            onClick={e =>
                              handleClick(e, el?.ScheduledBillingID, index, el)
                            }
                          >
                            <MoreVert />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          edge="end"
                          aria-label="arrow"
                          disabled={handlePermDisabled({
                            companyID: CompanyID,
                            permEnum:
                              AcctPermission.AccReceivableProformaInvoiceRequisitionView,
                          })}
                        >
                          <KeyboardArrowRight
                            onClick={() =>
                              history.push({
                                pathname: `/account-receivable/${CompanyID}/proforma-invoices/proforma-invoice-requisition/${el?.ProformaRequisitionID}/detail`,
                                state: el,
                              })
                            }
                          />
                        </IconButton>
                      )}
                    </ListItemSecondaryAction>
                  </ListItem>
                )
              })}
            </InfiniteScroll>
          )}
        </List>
        {listStatus === 'ACTIVE' && (
          <FloatButton
            onClick={() => {
              history.push(
                `/account-receivable/${CompanyID}/proforma-invoices/proforma-invoice-requisition/add`
              )
            }}
            disabled={handlePermDisabled({
              companyID: CompanyID,
              permEnum:
                AcctPermission.AccReceivableProformaInvoiceRequisitionCreate,
            })}
          />
        )}
      </ContentWrapper>

      {(listStatus === 'ACTIVE' || listStatus === 'REJECTED') && (
        <Menu
          id="menu-list"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          onClick={handleClose}
        >
          {listStatus === 'ACTIVE' && (
            <>
              <MenuItem
                disabled={handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.AccReceivableProformaInvoiceRequisitionUpdate,
                })}
                onClick={() => {
                  history.push({
                    pathname: `/account-receivable/${CompanyID}/proforma-invoices/proforma-invoice-requisition/${menu?.obj?.ProformaRequisitionID}/edit`,
                    state: menu?.obj,
                  })
                }}
              >
                Edit
              </MenuItem>

              <MenuItem
                disabled={handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.AccReceivableProformaInvoiceRequisitionDelete,
                })}
                onClick={() => setDeleteAA(true)}
              >
                Delete
              </MenuItem>
            </>
          )}

          {listStatus === ApprovalStatus.Rejected && (
            <MenuItem
              onClick={() =>
                history.push({
                  pathname: `/account-receivable/${CompanyID}/proforma-invoices/proforma-invoice-requisition/${menu?.obj?.ProformaRequisitionID}/edit`,
                  state: { ...menu?.obj, mode: 'resubmit' },
                })
              }
              disabled={
                companyStatus === 'INACTIVE' ||
                handlePermDisabled({
                  companyID: CompanyID,
                  permEnum:
                    AcctPermission.AccReceivableProformaInvoiceRequisitionUpdate,
                })
                  ? true
                  : false
              }
            >
              Resubmit
            </MenuItem>
          )}
        </Menu>
      )}

      <DeleteDialog
        ID={menu?.obj?.ProformaRequisitionID}
        openDeleteDialog={deleteAA}
        setOpenDeleteDialog={setDeleteAA}
        title={'Proforma Invoice'}
        menu={menu?.obj}
        handleDelete={handleDelete}
        passID={menu?.obj?.ProformaRequisitionID}
      />

      <ErrorDialog
        errorDia={errorDia}
        setErrorDia={setErrorDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
